
import React, { Component } from 'react';
import { render } from 'react-dom';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Dialog, DialogType, DialogFooter } from 'office-ui-fabric-react/lib/Dialog';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

let resolve;

const STYLES = {
    subComponentStyles: {
        label: {
            root: {
                color: '#999999'
            }
        }
    }
};

const classNames = mergeStyleSets({
    dialogContent: {
    },
    title: {
        width: 150
    },
    count: {
        width: 100
    },
    warning: {
        color: '#ff0000'
    }
});

const DialogContent = ({id_usek, warnings, onChange}) => {

    const handleChange = (e) => {
        if (onChange) {
            onChange('id_usek', e.target.value);
        }
    }

    const renderWarnings = () => {
        return (
            <div>
                {warnings.map((item, index) => {
                    return <div key={index} className={classNames.warning}>{item}</div>;
                })}
            </div>
        );
    }

    return (
        <div className={classNames.dialogContent}>
            <Stack tokens={{childrenGap: 8}}>
                <TextField
                    label="ID úseku meze"
                    value={id_usek}
                    onChange={handleChange}
                    styles={STYLES}
                />
                {(warnings.length > 0) && renderWarnings()}
            </Stack>
        </div>
    );
}

class DialogEditUsekAttr extends Component {

    static create() {
        const containerElement = document.createElement('div');
        document.body.appendChild(containerElement);
        return render(<DialogEditUsekAttr />, containerElement);
    }

    constructor(props) {
        super(props);
        this.state = {
            hidden: !props.show,
            id_usek: '',
            id_usek_original: '',
            existingIdArr: [],
            allowDelete: false
        };
    }

    getWarinings() {
        let warnings = [];
        if (this.state.id_usek !== this.state.id_usek_original) {
            const exists = this.state.existingIdArr.reduce((previous, current) => {
                return (current === this.state.id_usek)
                    ? true
                    : previous;
            }, false);
            if (exists) {
                warnings.push(`Zadané ID úseku meze již existuje`);
            }
        }
        return warnings;
    }

    checkValues() {
        let warnings = this.getWarinings();
        return (warnings.length === 0);
    }

    handleCancel = () => {
        this.setState({hidden: true});
        resolve(null);
    }

    handleConfirm = () => {
        if (this.checkValues()) {
            this.setState({hidden: true});
            resolve({
                result: 'OK',
                attrs: {
                    id_usek: this.state.id_usek
                }
            });
        }
    }

    handleChange = (name, value) => {
        this.setState({
            [name]: value
        });
    }

    handleDelete = () => {
        this.setState({hidden: true});
        resolve({
            result: 'DELETE'
        });
    }

    render () {
        return (
            <Dialog
                hidden={this.state.hidden}
                minWidth={500}
                onDismiss={this.handleCancel}
                dialogContentProps={{
                    type: DialogType.normal,
                    title: "Úsek meze"
                }}
                modalProps={{
                    isBlocking: false
                }}
                >
                    <DialogContent
                        id_usek={this.state.id_usek}
                        warnings={this.getWarinings()}
                        onChange={this.handleChange}
                    />
                <DialogFooter>
                    <PrimaryButton onClick={this.handleConfirm} text="Uložit" disabled={!this.checkValues()} />
                    <DefaultButton onClick={this.handleCancel} text="Zrušit" />
                    {this.state.allowDelete && <DefaultButton onClick={this.handleDelete} text="Smazat úsek" />}
                </DialogFooter>
            </Dialog>
        );
    }

    show(id_usek, allowDelete, existingIdArr) {
        this.setState({
            hidden: false,
            id_usek: id_usek,
            id_usek_original: id_usek,
            existingIdArr: existingIdArr,
            allowDelete: (allowDelete === true)
        });
        return new Promise((res) => {
            resolve = res;
        });
    }
}

export default DialogEditUsekAttr.create();
